import { memo } from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { geocodeByPlaceId, getLatLng } from "react-places-autocomplete";

// Components
import {
  NumberFormatterInput,
  TextField,
  Button,
  FileUpload,
  GooglePlacesAutoComplete
} from "../../../components/UI";

// Builders
import * as buttonDesignType from "../../../builders/buttonDesign.types";

// UI models
import { BussinesForm } from "../../../models/app/forms";

// Icons
import { DropDownArrow } from "../../../SVGS";

// Actions
import { register } from "../../../redux/actions/app.actions";

// Services
import { registerStepTwoValidation } from "../../../services/validations/register.validations";

// Styles
import { RegisterStepTwoFormStyles } from "./resiterStepTwoForm.styles";

const RegisterStepTwoForm = ({ accountForm, bussinessForm, handleBack }) => {
  const dispatch = useDispatch();

  const handleRegister = values => {
    dispatch(register({ account: accountForm, business: values }));
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: bussinessForm,
    onSubmit: handleRegister,
    validate: registerStepTwoValidation
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleChange,
    setFieldValue,
    setFieldTouched,
    setValues,
    handleBlur
  } = formik;

  const handleAddressChange = address => {
    setFieldValue("address", address);
  };

  const prefillFieldsBasedOnAddress = async (chosenAddress, placeId) => {
    const [place] = await geocodeByPlaceId(placeId);
    const latLng = await getLatLng(place);

    const { long_name: postalCode = "" } =
      place.address_components.find(c => c.types.includes("postal_code")) || {};
    const { long_name: state = "" } =
      place.address_components.find(c => c.types.includes("country")) || {};
    const { long_name: city = "" } =
      place.address_components.find(c => c.types.includes("locality")) || {};
    const address = place.formatted_address;
    const longitude = latLng.lng;
    const latitude = latLng.lat;

    setValues(
      new BussinesForm({
        ...values,
        city,
        state,
        address,
        latitude,
        longitude,
        postalCode
      })
    );
  };

  return (
    <RegisterStepTwoFormStyles>
      <Button onClick={() => handleBack(values)} className="backButton">
        <div className="arrowContainer">
          <DropDownArrow />
        </div>
        Back
      </Button>
      <form className="form" autoComplete="off" onSubmit={handleSubmit}>
        <div>
          <TextField
            value={values.name}
            touched={touched.name}
            error={errors.name}
            onBlur={handleBlur}
            onChange={handleChange}
            name="name"
            placeholder="Business Name"
          />
        </div>
        <div>
          <GooglePlacesAutoComplete
            value={values.address}
            touched={touched.address}
            error={errors.address}
            onBlur={handleBlur}
            handleChange={handleAddressChange}
            handleSelect={prefillFieldsBasedOnAddress}
            name="address"
            placeholder="Address"
          />
        </div>
        <div className="alignedInputs">
          <div className="inputContainer">
            <TextField
              value={values.state}
              touched={touched.state}
              error={errors.state}
              onBlur={handleBlur}
              onChange={handleChange}
              name="state"
              placeholder="State"
            />
          </div>
          <div className="inputContainer">
            <TextField
              value={values.city}
              placeholder="City"
              onBlur={handleBlur}
              onChange={handleChange}
              name="city"
              touched={touched.city}
              error={errors.city}
            />
          </div>
        </div>
        <div className="alignedInputs">
          <div className="inputContainer">
            <TextField
              value={values.postalCode}
              touched={touched.postalCode}
              error={errors.postalCode}
              onBlur={handleBlur}
              onChange={handleChange}
              name="postalCode"
              placeholder="Postal Code"
            />
          </div>
          <div className="inputContainer">
            <NumberFormatterInput
              value={values.taxId}
              touched={touched.taxId}
              error={errors.taxId}
              onBlur={setFieldTouched}
              onChange={setFieldValue}
              name="taxId"
              placeholder="Tax ID Number"
            />
          </div>
        </div>
        <div>
          <FileUpload
            id="proofDocumentationUrl"
            name="proofDocumentationUrl"
            value={values.proofDocumentationUrl}
            setFieldValue={setFieldValue}
            touched={touched.proofDocumentationUrl}
            error={errors.proofDocumentationUrl}
          />
        </div>
        <div>
          <TextField
            value={values.websiteUrl}
            touched={touched.websiteUrl}
            error={errors.websiteUrl}
            onBlur={handleBlur}
            onChange={handleChange}
            name="websiteUrl"
            placeholder="Business Website"
          />
        </div>
        <Button
          type="submit"
          className="submitButton"
          buttonDesignType={buttonDesignType.PRIMARY}
        >
          Register
        </Button>
      </form>
    </RegisterStepTwoFormStyles>
  );
};

export default memo(RegisterStepTwoForm);
